import { useState } from "react";

import { map } from "lodash/fp";

import { Collapse, Typography } from "@mui/material";

import AttendanceIndicator from "@app/analytics/components/AttendanceIndicator";
import { Participant } from "@app/analytics/MeetingReport/types";
import { pluralizePhrase } from "@app/common/utils";

import { Row } from "@rui/Stack";

import { Card, Name, CollapseContentWrapper } from "./styles";

const AbsentParticipantsCard = ({
  participants,
}: {
  participants: Participant[];
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleOpen = () => setIsOpen(!isOpen);

  const participantList = map("name", participants).join(", ");

  return (
    <Card open={isOpen} onClick={handleToggleOpen}>
      <Row variant="left" spacing={1}>
        <AttendanceIndicator type="missed" />
        <Name>
          {pluralizePhrase(participants.length, "person", { plural: "people" })}{" "}
          absent
        </Name>
      </Row>
      <Collapse in={isOpen}>
        <CollapseContentWrapper>
          <Typography
            sx={{ color: "shades.neutral.900", fontSize: "0.8125rem" }}
          >
            {participantList}
          </Typography>
        </CollapseContentWrapper>
      </Collapse>
    </Card>
  );
};

export default AbsentParticipantsCard;
